import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'linaria';
import Avatar from './avatar';
const buttonStyles = "b502wo9";
/**
 * Component that wraps the avatar component in a <button> and handles the interaction
 * styles of that button.
 */
// eslint-disable-next-line react/display-name

export const AvatarButton = React.forwardRef(({
  id,
  size,
  label,
  src,
  onClick,
  className,
  ...rest
}, ref) => {
  return <button type="button" className={cx(buttonStyles, className && className)} title={label} onClick={onClick} {...rest} ref={ref}>
        <Avatar size={size} src={src} altText={label} data-cy={`avatar-button-avatar-${id}`} />
      </button>;
});
AvatarButton.propTypes = {
  /**
   * Width/height of the avatar. Since the avatar will be square, this value is
   * both width and height.
   */
  size: PropTypes.string.isRequired,

  /**
   * Alt text to include as the button label of the Avatar for non-sighted users
   */
  label: PropTypes.string,

  /**
   * Provide an id if you have multiple instances per page and need unique
   * identifiers for tests.
   */
  id: PropTypes.string,

  /**
   * The src/url for the avatar image
   */
  src: PropTypes.string,

  /**
   * Callback called when the button is clicked.
   */
  onClick: PropTypes.func,

  /**
   * Classname to be applied to the outer node that can be used to override
   * or supplement styles.
   */
  className: PropTypes.string
};
AvatarButton.defaultProps = {
  label: '',
  id: '',
  src: null,

  onClick() {},

  className: null
};

require("./avatar-button.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./avatar-button.js");